import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { filterControl } from './ColumnMenu'
import { valueAt } from './ColumnTable'

/**
 * The few filters this person reaches for most, inline beside the pager.
 *
 * Every filter still lives on its column and is still reachable from the column's own menu — this
 * is a shortcut to the handful someone uses constantly, not a second filter bar. Which few those
 * are is decided by the caller from `usage`, so the row is theirs rather than everyone's.
 *
 * The controls come from `filterControl`, the same renderer the column menu uses, so a quick field
 * and its menu behave identically rather than drifting apart.
 */
export default function QuickFilters({
  columns,
  filters,
  onFilter,
  width = 160,
}) {
  const { t } = useTranslation('common')
  const withFilters = (columns || []).filter((column) => column?.filter)

  if (!withFilters.length) return null

  return (
    <>
      {withFilters.map((column) => (
        <Box key={column.id} sx={{ width, flexShrink: 0 }}>
          {filterControl({
            column,
            value: valueAt(filters, column.filter.path),
            onChange: (value) => onFilter(column.filter.path, value, column),
            t,
          })}
        </Box>
      ))}
    </>
  )
}
